var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 154,
    viewBox: "0 0 147 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7876 47.8276C15.7632 68.712 25.1063 91.8351 34.7677 114.435C38.3524 122.82 42.0158 131.321 45.0474 139.956",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9861 48.2847C35.5465 33.623 67.8757 18.4737 100.251 3.39709",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.25 3.396C104.858 10.4357 107.865 18.4212 111.219 26.1252C115.929 36.9407 120.638 47.7562 125.348 58.5717C129.591 68.3158 133.834 78.0599 138.077 87.804C139.035 90.0039 140.883 92.7499 140.77 95.2188",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7544 139.45C47.0391 146.533 57.2409 143.422 63.0637 141.955C66.5844 141.069 70.0941 139.443 73.4659 138.089C77.6278 136.418 81.9179 135.342 86.047 133.483C99.3056 127.513 107.273 124.089 120.152 117.445C123.277 115.833 126.419 113.743 129.656 112.286C132.972 110.793 136.253 106.712 139.457 105.16C145.635 102.167 136.472 82.0577 134.612 79.6311",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9051 46.8547C21.3477 48.1519 17.9328 46.0866 16.2697 41.874C15.4577 39.8173 16.2834 38.1279 18.1805 37.0322C20.1595 35.8892 22.2573 36.329 23.2239 38.5488",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3338 42.1584C31.7764 43.4556 28.3615 41.3903 26.6984 37.1778C25.8864 35.121 26.7121 33.4316 28.6092 32.3359C30.5882 31.1929 32.686 31.6327 33.6526 33.8525",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.762 37.4626C42.2046 38.7598 38.7898 36.6945 37.1266 32.482C36.3146 30.4252 37.1404 28.7358 39.0374 27.6401C41.0164 26.4971 43.1142 26.9369 44.0808 29.1567",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1907 32.7668C52.6333 34.064 49.2185 31.9987 47.5553 27.7862C46.7433 25.7294 47.5691 24.04 49.4662 22.9443C51.4452 21.8013 53.5429 22.2411 54.5095 24.4609",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6189 28.071C63.0615 29.3682 59.6467 27.3029 57.9836 23.0904C57.1716 21.0336 57.9973 19.3442 59.8944 18.2485C61.8734 17.1055 63.9712 17.5453 64.9378 19.7651",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0472 23.3747C73.4897 24.6719 70.0749 22.6066 68.4118 18.3941C67.5998 16.3374 68.4255 14.6479 70.3226 13.5522C72.3016 12.4092 74.3994 12.849 75.366 15.0689",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4759 18.6799C83.9185 19.9771 80.5036 17.9118 78.8405 13.6992C78.0285 11.6425 78.8542 9.95305 80.7513 8.85737C82.7303 7.71439 84.8281 8.15422 85.7947 10.374",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5664 71.1108C27.0612 73.3977 30.9898 80.584 29.8965 78.0732",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1107 70.8658C27.5078 70.2367 28.9049 69.6076 30.302 68.9785C31.2801 68.5381 33.7372 66.8658 34.9586 67.2485C36.9057 67.8586 38.2306 72.6493 39.0004 74.3773C39.2376 74.9097 40.2518 76.323 39.1584 76.3966C35.926 76.6143 32.8981 78.3721 29.9561 79.6968",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8901 61.9585C47.3849 64.2454 51.3135 71.4317 50.2202 68.9209",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4345 61.7135C47.8316 61.0844 49.2287 60.4553 50.6258 59.8262C51.6038 59.3858 54.061 57.7135 55.2823 58.0961C57.2295 58.7062 58.5543 63.497 59.3242 65.2249C59.5614 65.7574 60.5755 67.1707 59.4822 67.2443C56.2497 67.462 53.2218 69.2198 50.2798 70.5445",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1719 94.7832C38.6667 97.0701 42.5952 104.256 41.5019 101.746",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7162 94.5382C39.1133 93.9091 40.5104 93.28 41.9075 92.6509C42.8855 92.2105 45.3427 90.5382 46.564 90.9208C48.5112 91.531 49.836 96.3217 50.6059 98.0497C50.8431 98.5821 51.8573 99.9954 50.7639 100.069C47.5315 100.287 44.5035 102.044 41.5616 103.369",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9678 110.39C45.4626 112.677 49.3911 119.863 48.2978 117.352",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5121 110.145C45.9092 109.516 47.3063 108.887 48.7034 108.258C49.6814 107.817 52.1386 106.145 53.3599 106.528C55.3071 107.138 56.6319 111.929 57.4018 113.657C57.639 114.189 58.6532 115.602 57.5598 115.676C54.3274 115.894 51.2994 117.651 48.3575 118.976",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4106 124.441C51.9054 126.728 55.834 133.914 54.7407 131.403",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9555 124.196C52.3526 123.567 53.7497 122.938 55.1468 122.309C56.1248 121.869 58.582 120.196 59.8033 120.579C61.7504 121.189 63.0753 125.98 63.8452 127.708C64.0824 128.24 65.0965 129.654 64.0031 129.727C60.7707 129.945 57.7428 131.703 54.8008 133.027",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2168 52.8062C67.7116 55.093 71.6402 62.2793 70.5468 59.7685",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7611 52.5611C68.1582 51.932 69.5553 51.3029 70.9524 50.6738C71.9305 50.2334 74.3876 48.5611 75.6089 48.9438C77.5561 49.5539 78.881 54.3446 79.6508 56.0726C79.888 56.605 80.9022 58.0183 79.8088 58.092C76.5764 58.3096 73.5484 60.0674 70.6065 61.3922",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.542 43.6509C88.0368 45.9378 91.9654 53.1241 90.872 50.6132",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0878 43.4073C88.4849 42.7782 89.882 42.1491 91.2791 41.52C92.2571 41.0796 94.7143 39.4073 95.9356 39.79C97.8828 40.4001 99.2076 45.1908 99.9775 46.9188C100.215 47.4512 101.229 48.8645 100.135 48.9382C96.903 49.1558 93.8751 50.9136 90.9332 52.2383",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3459 73.5812C30.6107 72.6327 30.8745 71.7611 31.3954 70.9273C31.8506 70.1986 31.5114 71.2486 31.4979 71.6751C31.4702 72.5478 31.3602 73.7824 31.721 74.611C31.8762 74.9675 32.7708 73.67 32.8448 73.5466C32.9408 73.3864 33.3475 72.1168 33.4583 72.8079C33.6577 74.0513 33.3811 75.1305 33.3022 76.3508C33.2415 77.2894 34.4414 75.2247 34.5211 75.0516C34.8281 74.3845 35.1636 73.7424 35.5513 73.1219",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4962 71.7967C27.2055 59.1603 44.8419 52.8796 61.5163 45.3712C74.4435 39.5502 87.5791 34.169 100.487 28.3566C104.018 26.7666 107.528 26.2533 111.039 24.6724",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5401 90.7785C76.8666 80.6005 97.5375 73.1338 117.056 63.3579",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6111 83.8363C95.1353 78.1967 107.517 72.311 120.028 66.6771",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9624 100.634C89.7088 93.9936 104.455 87.3534 119.201 80.7132C121.079 79.868 122.677 79.1397 124.718 78.8502",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72559 48.4771C3.93659 53.9658 4.73435 60.0769 6.19181 65.7959C8.19135 73.642 9.92788 81.5961 12.1378 89.3802C14.8011 98.7613 16.7864 108.208 17.2497 117.985C17.3632 120.378 17.7166 122.665 18.4067 124.921C18.7421 126.017 18.6378 127.132 18.7833 128.259C18.9982 129.922 19.5177 131.444 20.1824 132.965C20.9694 134.765 21.5043 136.454 21.9581 138.355C22.218 139.443 22.345 140.948 22.9132 141.911C23.5301 142.957 23.8964 143.88 24.2988 145.017C24.8156 146.476 25.9988 147.712 26.7068 149.08C27.1698 149.974 28.334 150.779 29.2763 151.05C30.2045 151.316 31.0453 151.686 31.9399 152.035C32.9266 152.419 34.3306 151.49 35.1954 151.159C36.8971 150.508 38.6204 149.803 40.388 149.353C41.2419 149.136 42.1022 149.128 42.944 148.834C44.3166 148.354 45.7091 146.763 47.1277 146.459C48.0171 146.269 62.9023 141.911 62.9023 141.911",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45215 49.2139C2.82378 58.0949 6.77071 66.6235 9.44744 74.9596C10.8892 79.4498 11.8675 84.1874 13.9137 88.4481C14.631 89.9418 14.7826 91.8048 15.2858 93.4003C16.0549 95.8387 16.436 98.3508 17.4651 100.705C19.587 105.56 19.8745 111.117 21.0973 116.218C21.9115 119.615 23.4555 122.698 24.4335 126.041C25.1871 128.616 25.8006 131.211 27.1644 133.551C28.7889 136.339 30.603 139.008 31.8324 142.019C32.8811 144.587 34.2966 146.604 36.191 148.531C36.5928 148.939 37.0646 149.173 37.4555 149.57",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90527 49.708C4.18656 52.8545 4.71764 55.8737 5.86934 58.8189C7.81826 63.8028 9.39005 68.9048 11.2503 73.9216C13.0871 78.8751 15.4501 83.5848 17.008 88.6413C17.7564 91.0704 18.9308 93.2601 19.7657 95.6454C20.5264 97.8185 21.5307 99.8734 22.5639 101.925C23.9902 104.756 25.0731 107.678 26.3037 110.598C27.4218 113.251 28.6892 115.831 29.9358 118.423C31.4144 121.497 32.5569 124.675 34.1734 127.684C35.3026 129.786 36.5156 131.913 37.5096 134.086C38.1537 135.495 38.4587 137.02 39.0701 138.436C39.8746 140.301 41.508 142.185 41.9354 144.141C42.0752 144.78 42.9394 145.988 43.3749 146.494",
    stroke: "#FB7C51",
    strokeWidth: 2.36988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDark);
export default __webpack_public_path__ + "static/media/calendarDark.29f73c3dfa2d5b3f6371f9da496367dc.svg";
export { ForwardRef as ReactComponent };